// extracted by mini-css-extract-plugin
module.exports = {"link":"previewSuspense_link__887zN"};